var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1361 10.2416C10.0492 10.8779 10.093 11.5264 10.2644 12.1432C10.4358 12.7601 10.731 13.3308 11.1297 13.8166C11.5285 14.3025 12.0216 14.6921 12.5755 14.9591C13.1295 15.2261 13.7314 15.3643 14.3404 15.3641L17.944 15.3641C19.0574 15.3437 20.1187 14.8625 20.8992 14.0242C21.6797 13.1858 22.1171 12.0574 22.1171 10.882C22.1171 9.70652 21.6797 8.5781 20.8992 7.73975C20.1187 6.9014 19.0574 6.42019 17.944 6.39976L15.8839 6.39342",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7396 11.5096C13.8265 10.8733 13.7827 10.2248 13.6113 9.60799C13.4399 8.99116 13.1448 8.42047 12.746 7.93462C12.3473 7.44877 11.8542 7.05912 11.3002 6.79211C10.7462 6.5251 10.1443 6.38696 9.53536 6.38708L5.93172 6.38708C4.81832 6.40751 3.75706 6.88872 2.97651 7.72707C2.19597 8.56542 1.7586 9.69383 1.7586 10.8693C1.7586 12.0447 2.19597 13.1731 2.97651 14.0115C3.75706 14.8498 4.81832 15.331 5.93172 15.3515L7.9858 15.3515",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b30d4a0e6577748f3b3c359e07eb6646.svg";
export { ForwardRef as ReactComponent };